import { gql } from "@apollo/client";

export const SAVE_INSURANCE_DATA = gql`
  mutation saveInsuranceData($input: InsuranceDataInput!) {
    saveInsuranceData(input: $input) {
      commandId
      correlationId
    }
  }
`;
